// @ts-nocheck
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { find, get } from 'lodash'
import Actions from '../../../actions'
import Operations from '../../../operations'
import Selectors from '../../../selectors'
import { postJSON } from '../../../common/services/api'
import { sizes } from '@lmc/common/constants'
import { getNominative } from '../../../common/utils'

import { Spinner, Step, StepList } from '../../generic'
import { ScrollLock } from '../../../LEGACY/elemental'
import Modal from '..'
import RiskAssessmentForm from '../../forms/screens/RiskAssessmentForm'
import {
  AssessmentTitleScreen,
  AssessmentQuestionScreen,
  CreateAssessmentDashboard,
} from './components'
import { withRouter } from '../../../withRouter'

/**
 * Two use cases for CreateRiskAssessment:
 * 1. Updating an existing riskAssessment (props.completedRiskAssessment === { RiskAssessment })
 *    Skip straight to renderEditForm
 *    There is a problem with assessments which filled out forms that have since been edited.
 *    Forms where `isRevision === true` are not included in `loadList('forms')`, so they need
 *    to be fetched individually
 * 2. Filling out a Blank Risk Assessment (props.completedRiskAssessment === null)
 *    Render a step list, requiring a list of all available forms from `loadList('forms')`
 */
export class CreateRiskAssessment extends React.Component {
  state = {
    addCustom: false,
    addExisting: false,
    customName: '',
    existingRiskAssessment: null,
    riskAssessmentFormId: null,
    parentFormId: null,
  }

  componentDidUpdate(prevProps) {
    const {
      isOpen,
      loadList,
      completedRiskAssessment,
      router: { params },
      parentFormId,
    } = this.props

    if (!this.state.parentFormId && parentFormId) {
      this.setState({ parentFormId })
    }

    const residentId = params.id

    if (!completedRiskAssessment && !prevProps.isOpen && isOpen && params && residentId) {
      loadList('risk-assessments', {
        mostRecent: true,
        resident: residentId,
        withFormData: true,
      })
      loadList('forms', {
        type: 'risk-assessment',
      })
    }
  }

  onFormClose = () => {
    this.setState({
      existingRiskAssessment: null,
      riskAssessmentFormId: null,
    })
    this.props.close()
  }

  onComplete = (item) => {
    const { addRiskAssessment, setLoadedListItem, showToast } = this.props
    setLoadedListItem('risk-assessments', item)
    showToast({ title: 'Complete' })
    if (this?.state?.parentFormId) {
      addRiskAssessment(item.id, this.state.parentFormId)
    }
    this.onFormClose()
  }

  handleAddNew = (id, isCustom, callback) =>
    this.setState(
      {
        addCustom: isCustom || false,
        addExisting: false,
        customName: '',
        existingRiskAssessment: null,
        riskAssessmentFormId: id,
      },
      callback
    )

  handleAddExisting = (existingRiskAssessment, callback) =>
    this.setState(
      {
        addCustom: false,
        addExisting: true,
        customName: '',
        existingRiskAssessment,
        riskAssessmentFormId: existingRiskAssessment.form.id,
      },
      callback
    )

  handleAttachBlank = () =>
    this.setState({
      addExisting: false,
      customName: '',
      existingRiskAssessment: null,
    })

  handleCustomNameChange = (customName) => this.setState({ customName })

  handleCompleteLater = (item) => {
    if (!item) return alert(INTERNAL_ERROR)

    const isExisting = this.isExistingAssessment(item)
    const id = isExisting ? item.form.id : item.id

    if (this.state.addExisting) {
      const assessmentItem = isExisting ? item : this.findItem(item.id)
      this.onComplete(assessmentItem)
    } else {
      let name
      if (this.state.customName) {
        const parentFormId = isExisting ? item.form.name : item.name
        name = `${parentFormId} for ${this.state.customName}`
      }
      const json = {
        form: id,
        formData: {},
        incomplete: true,
        name,
        resident: this.props.router.params.id,
      }
      postJSON({
        url: 'list/risk-assessments',
        method: 'POST',
        json,
      })
        .then((res) => {
          this.onComplete(res.result)
        })
        .catch((e) => {
          console.log('Error:', e)
          alert(e)
        })
    }
  }

  findItem = (id) =>
    find(this.props.formsAndAssessments, (item) => {
      if (item.form && item.form.id) {
        return id === item.form.id
      }
      return id === item.id
    })

  isCompletedAssessment = () => {
    const { existingRiskAssessment } = this.state
    return existingRiskAssessment && !existingRiskAssessment.incomplete
  }

  isExistingAssessment = (assessment) => assessment.form && assessment.form.id

  renderEditForm = () => {
    const { completedRiskAssessment, close, attachToCarePlan } = this.props

    const displayCarePlanIfAdlRecordExists = attachToCarePlan?.carePlanAdl
      ?.name && [attachToCarePlan?.carePlanAdl]

    return (
      <StepList
        displayDots={false}
        displaySubmit={false}
        displaySelection={false}
        onClose={close}
        closeLabel="Cancel"
        stepStyle={styles.step}
      >
        <Step
          component={RiskAssessmentForm}
          carePlansDefault={
            // We need eitherways existing completedRiskAssessment or attached care plans from the form
            completedRiskAssessment.carePlans ||
            displayCarePlanIfAdlRecordExists
          }
          form_id={completedRiskAssessment.form.id}
          formData={completedRiskAssessment.formData}
          isCustom={this.state.addCustom}
          isModal
          onComplete={this.onComplete}
          onCancel={this.onFormClose}
          router={this.props.router}
          riskAssessmentId={completedRiskAssessment.id}
        />
      </StepList>
    )
  }

  renderFormStep = () => {
    const { existingRiskAssessment } = this.state

    const form_id = existingRiskAssessment
      ? existingRiskAssessment.form.id
      : this.state.riskAssessmentFormId

    const formData = existingRiskAssessment
      ? existingRiskAssessment.formData
      : null

    const riskAssessmentId = existingRiskAssessment
      ? existingRiskAssessment.id
      : null

    const displayCarePlanIfAdlRecordExists = this.props.attachToCarePlan
      ?.carePlanAdl?.name && [this.props.attachToCarePlan?.carePlanAdl]

    return (
      <Step
        component={RiskAssessmentForm}
        // We need eitherways existing existingRiskAssessment or attached care plans from the form
        carePlansDefault={
          (existingRiskAssessment ? existingRiskAssessment?.carePlans : null) ||
          displayCarePlanIfAdlRecordExists
        }
        form_id={form_id}
        formData={formData}
        customName={this.state.customName}
        isModal
        onComplete={this.onComplete}
        onCancel={this.onFormClose}
        router={this.props.router}
        riskAssessmentId={riskAssessmentId}
      />
    )
  }

  renderStepList = () => {
    const {
      carers,
      close,
      formsAndAssessments,
      carePlanNominative,
      preferredPeopleNominative,
      router: { params },
      ...formProps
    } = this.props

    const { addCustom, addExisting, customName, riskAssessmentFormId } =
      this.state

    const currentItem = this.findItem(riskAssessmentFormId)

    let form
    if (currentItem) form = currentItem.form || currentItem

    const carePlansToAttach = params?.care_plan_id

    return (
      <StepList
        displaySelection={false}
        displaySubmit={false}
        onClose={close}
        closeLabel="Cancel"
        stepStyle={styles.step}
      >
        <Step
          component={CreateAssessmentDashboard}
          data={{ carers, formsAndAssessments, carePlanNominative }}
          addNew={this.handleAddNew}
          addExisting={this.handleAddExisting}
          {...formProps}
        />

        {addCustom && (
          <Step
            component={AssessmentTitleScreen}
            form={form}
            onChange={this.handleCustomNameChange}
            value={customName}
            {...formProps}
          />
        )}
        {addExisting && this.isCompletedAssessment() && (
          <Step
            component={AssessmentQuestionScreen}
            continueOnPrimaryAction
            form={form}
            note={getAlreadyCompletedNote(preferredPeopleNominative)}
            onPrimaryAction={this.handleAttachBlank}
            onSecondaryAction={this.handleCompleteLater}
            options={ALREADY_COMPLETED_OPTIONS}
            primaryButtonText="Next Step"
            question={getAlreadyCompletedQuestion(preferredPeopleNominative)}
            {...formProps}
          />
        )}
        {carePlansToAttach && !addExisting && (
          <Step
            component={AssessmentQuestionScreen}
            form={form}
            note={getAttachAssessmentNote(carePlanNominative)}
            onPrimaryAction={this.handleCompleteLater}
            options={ATTACH_ASSESSMENT_OPTIONS}
            question={ATTACH_ASSESSMENT_QUESTION}
            {...formProps}
          />
        )}
        {this.renderFormStep()}
      </StepList>
    )
  }

  render() {
    const {
      carers,
      completedRiskAssessment,
      formsAndAssessments,
      isOpen,
      router,
    } = this.props

    if (!isOpen || !carers || !router || !router.params) return null
    if (!completedRiskAssessment && !formsAndAssessments) return <Spinner />
    return (
      <div style={styles.container}>
        <div style={styles.formContainer}>
          {completedRiskAssessment
            ? this.renderEditForm()
            : this.renderStepList()}
        </div>
        <ScrollLock />
      </div>
    )
  }
}

const getAlreadyCompletedNote = (preferredPeopleNominative) =>
  `You can choose to attach the already completed Assessment or fill out a new blank Assessment. If you choose to start a blank Assessment, this will overwrite the previously completed Assessment for this ${getNominative(
    preferredPeopleNominative,
    'Resident'
  )}.`
const getAlreadyCompletedQuestion = (preferredPeopleNominative) =>
  `This Assessment has already been completed for this ${getNominative(
    preferredPeopleNominative,
    'Resident'
  )}`
const getAttachAssessmentNote = (carePlanNominative) =>
  `This Assessment will be attached to the ${getNominative(
    carePlanNominative,
    'Care Plan'
  )}. You can choose to fill it out now or later.`
const ALREADY_COMPLETED_OPTIONS = [
  { value: 'Attach the completed assessment' },
  { value: 'Fill out a new blank assessment', primary: true },
]
const ATTACH_ASSESSMENT_OPTIONS = [
  { value: 'Now' },
  { value: 'Later', primary: true },
]
const ATTACH_ASSESSMENT_QUESTION =
  'Would you like to complete this Assessment now or later?'

const FORM_ID = 'createRiskAssessment'
const INTERNAL_ERROR =
  'Oops! Something went wrong. Please refresh the page and try again.'

const styles = {
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    margin: '0 auto',
    zIndex: 100,
    background: 'white',
  },
  formContainer: {
    height: '100vh',
    padding: '12px 12px 0px',
    overflow: 'auto',
  },
  step: {
    maxWidth: sizes.childScreen,
    margin: '0 auto',
    padding: '20px 20px 50px',
  },
}

CreateRiskAssessment.propTypes = {
  addRiskAssessment: PropTypes.func.isRequired,
  carePlanFormData: PropTypes.object,
  carers: PropTypes.array,
  parentFormId: PropTypes.string,
  formsAndAssessments: PropTypes.array,
  loadList: PropTypes.func.isRequired,
  setLoadedListItem: PropTypes.func.isRequired,
}

const mapStateToProps = (state, props) => ({
  carers: state.data.carers,
  carePlanFormData: get(state, `forms.${props.parentFormId}.fields`),
  formsAndAssessments: Selectors.concatenateFormsAndAssessments(state),
  carePlanNominative: state.global.home.preferredCarePlansNominative,
  preferredPeopleNominative: state.global.home.preferredPeopleNominative,
})

const mapDispatchToProps = (dispatch) => ({
  setLoadedListItem: (list_id, item) =>
    dispatch(Actions.setLoadedListItem(list_id, item)),
  addRiskAssessment: (id, formId) =>
    dispatch(Operations.addCarePlanRiskAssessment(id, formId)),
  loadList: (list_id, query) => dispatch(Operations.loadList(list_id, query)),
})

const wrappedModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CreateRiskAssessment))

export default Modal(wrappedModal, FORM_ID)
